export default "<app-layout></app-layout>\n";